// Aggregates every per-page "extra" slot array into one EXTRA_SLOTS list that
// slots.ts concatenates onto the original CMS_SLOTS registry. This modular split
// lets each page's editable-content slots live in their own file, so additions
// never contend on the monolithic registry. Append-only, same rules as the main
// registry (see slots.ts header).
import type { SlotDef } from '../slots';
import { aboutExtra } from './about';
import { communityGuidelinesExtra } from './community_guidelines';
import { disputeResolutionExtra } from './dispute_resolution';
import { faqExtra } from './faq';
import { footerExtra } from './footer';
import { foundingVenueOfferExtra } from './founding_venue_offer';
import { homeExtra } from './home';
import { howItWorksExtra } from './how_it_works';
import { nextStepsExtra } from './next_steps';
import { notesFromTheRoadExtra } from './notes_from_the_road';
import { privacyExtra } from './privacy';
import { termsExtra } from './terms';
import { waitlistExtra } from './waitlist';
import { whatWeAreExtra } from './what_we_are_and_arent';

export const EXTRA_SLOTS: readonly SlotDef[] = [
  ...homeExtra,
  ...faqExtra,
  ...howItWorksExtra,
  ...foundingVenueOfferExtra,
  ...whatWeAreExtra,
  ...aboutExtra,
  ...disputeResolutionExtra,
  ...privacyExtra,
  ...termsExtra,
  ...communityGuidelinesExtra,
  ...notesFromTheRoadExtra,
  ...waitlistExtra,
  ...nextStepsExtra,
  ...footerExtra,
];
